import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { AUTH_GA_ACCOUNTS, AUTH_GA_CARD, AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { FAILED, requestsIssueVirtualCard, SUCCESS } from 'apps/auth/services/GaCardsService';

import ActivityLibreDetails from './ActivityLibreDetails';
import ChoosingUserBank from './ChoosingUserBank';
import HaveBankAccount from './HaveBankAccount';
import { CHOOSING_BANK, HAVE_BANK_ACCOUNT, HISTORY, KYC_IN_PROGRESS, MONEY_ADDED, SUBMITTED } from './LibreHistoryScreenConstants';
import OnfidoWaitingStatus from '../../../kyc/KYCOnfidoStatus/OnfidoWaitingStatus';

const LibreHistoryFlow = (props) => {
    const [screen, setScreen] = useState(HISTORY);
    const messages = usePageMessages();
    const extra = useExtra();

    const timerId = useRef(null);

    useEffect(() => {
        return () => clearTimeout(timerId.current);
    }, []);

    const startTimerAfterSubmit = () => {
        // два ModalWithTimer подряд не работают вместе, из-за этого реализовал отдельную логику
        setScreen(SUBMITTED);
        timerId.current = setTimeout(() => {
            props.toggleSpinner(true);
            requestsIssueVirtualCard(extra?.pocket?.id, props.toggleSpinner, props.addExtras, setScreen);
        }, 2000);
    };

    // Менять с осторожностью, логика используется в дочерних компонентах
    const doRequest = (e, url, fields, afterRequest) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(url, fields)
            .then((json) => {
                if (json.extra) {
                    props.addExtras(json.extra).then(() => {
                        if (json.extra.banks) {
                            setScreen(CHOOSING_BANK);
                            props.toggleSpinner(false);
                        } else if (afterRequest) {
                            afterRequest();
                        } else {
                            props.toggleSpinner(false);
                            startTimerAfterSubmit();
                        }
                    });
                }
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    const render = (currentScreen) => {
        switch (currentScreen) {
            case HISTORY:
                return (
                    <ModalComponent helpAndMore={messages.helpAndMore} onClickMoreIcon={props.moreClickHandler}>
                        <ActivityLibreDetails pocketId={props.pocketId} item={props.item} options={props.options} setScreen={setScreen} doRequest={doRequest} />
                    </ModalComponent>
                );
            case HAVE_BANK_ACCOUNT:
                return (
                    <ModalComponent
                        canCloseModal
                        onCloseIconClick={(e) => {
                            e.preventDefault();
                            setScreen(HISTORY);
                        }}
                    >
                        <HaveBankAccount messages={messages} doRequest={doRequest} setScreen={setScreen} />
                    </ModalComponent>
                );
            case CHOOSING_BANK:
                return <ChoosingUserBank messages={messages} setScreen={setScreen} startTimerAfterSubmit={startTimerAfterSubmit} />;
            case KYC_IN_PROGRESS:
                return <OnfidoWaitingStatus />;
            case SUCCESS:
                return <ModalWithTimer text={messages.messageCardActivated} onClick={() => setScreen(MONEY_ADDED)} />;
            case SUBMITTED:
                return (
                    <>
                        <ModalComponent canCloseModal={false} isVerticalCentered>
                            <InfoPage animatedIconSuccess mainText={messages.messageInformationSubmitted} insideModalComponent />
                        </ModalComponent>
                    </>
                );
            case MONEY_ADDED:
                return (
                    <ModalComponent canCloseModal={false} isVerticalCentered>
                        <InfoPage
                            insideModalComponent
                            iconName="cardp-mastercard-thin"
                            iconColor="primary"
                            headerText={messages.moneyAddedTitle}
                            topButtonType="link"
                            primaryButtonCaption={messages.continueButton}
                            primaryButtonType="button"
                            primaryButtonOnClick={() => {
                                window.location.href = extra.card?.id ? AUTH_GA_CARD + extra.card.id : AUTH_GA_CARDS;
                            }}
                        />
                    </ModalComponent>
                );
            case FAILED:
                return (
                    <ModalComponent isVerticalCentered>
                        <InfoPage
                            insideModalComponent
                            animatedIconFail
                            headerText={messages.OhWentWrong}
                            primaryButtonType="link"
                            primaryButtonCaption={messages.goBack}
                            primaryButtonLink={AUTH_GA_ACCOUNTS}
                        />
                    </ModalComponent>
                );
        }
    };
    return <>{render(screen)}</>;
};

export default connect(null, { toggleSpinner, addExtras })(LibreHistoryFlow);
